import { render, staticRenderFns } from "./AdminScripts.vue?vue&type=template&id=3379bbd5&"
import script from "./AdminScripts.vue?vue&type=script&lang=js&"
export * from "./AdminScripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports